import { render, staticRenderFns } from "./ZztZhongjianModal.vue?vue&type=template&id=6dede211&"
import script from "./ZztZhongjianModal.vue?vue&type=script&lang=js&"
export * from "./ZztZhongjianModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports